import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../Assets/Images/logo.png';
import LogoSticky from '../Assets/Images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

function Header() {
    const getActiveClass = ({ isActive }) => isActive ? 'active' : '';

    return (
        <>
            {/* <div className="header-top-bar">
                <div className="container">
                    <div className="header-phone"><FontAwesomeIcon icon={faPhone} />&nbsp;&nbsp; +1 123 45678 | +1 123 45678</div>
                    <NavLink className="header-email" to="mailto:info@fusionhub.com"><FontAwesomeIcon icon={faEnvelope} />&nbsp;&nbsp; info@fusionhub.com</NavLink>
                </div>
            </div> */}
            
            <nav className="navbar navbar-area navbar-expand-lg">
                <div className="container nav-container">
                    <div className="responsive-mobile-menu">
                        <div className="logo-wrapper mobile-logo">
                            <NavLink to='/' className="logo">
                                <img className="sticky-logo" src={Logo} alt="logo" />
                            </NavLink>
                        </div>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#riyaqas_main_menu" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggle-icon">
                                <span className="line"></span>
                                <span className="line"></span>
                                <span className="line"></span>
                            </span>
                        </button>
                    </div>
                    <div className="collapse navbar-collapse" id="riyaqas_main_menu">
                        <div className="logo-wrapper desktop-logo">
                            <NavLink to='/' className="logo">
                                <img className="sticky-logo" src={LogoSticky} alt="logo" />
                            </NavLink>
                        </div>
                        <ul className="navbar-nav">
                            <li>
                                <NavLink to='/' className={getActiveClass}>Home</NavLink>
                            </li>
                            <li>
                                <NavLink to='/about-us' className={getActiveClass}>About Us</NavLink>
                            </li>
                            <li className="menu-item-has-children">
                                <NavLink to='/services' className={getActiveClass}>
                                    Services <FontAwesomeIcon className='icon' icon={faAngleDown} />
                                </NavLink>
                                <ul className="sub-menu">
                                    <li className="menu-item-has-children">
                                        <NavLink to='/services/engineering-consultancy' className={getActiveClass}>
                                            Engineering Solutions <FontAwesomeIcon className='icon' icon={faAngleDown} />
                                        </NavLink>
                                        <ul className="sub-menu">
                                            <li>
                                                <NavLink to='/services/engineering-consultancy/civil-services' className={getActiveClass}>Civil Services</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/engineering-consultancy/solar-services' className={getActiveClass}>Solar Services</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/engineering-consultancy/lighting-services' className={getActiveClass}>Lighting Services</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <NavLink to='/services/digital-services' className={getActiveClass}>
                                            Digital & IT Services <FontAwesomeIcon className='icon' icon={faAngleDown} />
                                        </NavLink>
                                        <ul className="sub-menu">
                                            <li>
                                                <NavLink to='/services/digital-services/analytics' className={getActiveClass}>Analytics</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/digital-services/web-development' className={getActiveClass}>Web Development</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/digital-services/ai-solutions' className={getActiveClass}>AI Solutions</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/digital-services/app-&-software' className={getActiveClass}>App & Software</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/digital-services/marketing' className={getActiveClass}>Marketing </NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <NavLink to='/services/dedicated-resources-services' className={getActiveClass}>
                                            Dedicated Resource Services <FontAwesomeIcon className='icon' icon={faAngleDown} />
                                        </NavLink>
                                        <ul className="sub-menu">
                                            <li>
                                                <NavLink to='/services/dedicated-resources-services/hr-services' className={getActiveClass}>HR Services</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/dedicated-resources-services/business-operations' className={getActiveClass}>Business Operations</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/dedicated-resources-services/financial-services' className={getActiveClass}>Financial Services</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/services/dedicated-resources-services/administrative-services' className={getActiveClass}>Administrative Services</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <NavLink to="/faqs" className={getActiveClass}>FAQs</NavLink>
                            </li>
                            <li>
                                <NavLink to='/contact' className={getActiveClass}>Contact</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Header;
